<template>
  <v-app>
    <v-app-bar app flat color="white">
      <FullHeaderComponent />
    </v-app-bar>
    <v-main class="grey lighten-4 pt-14">
      <v-container fluid class="addListing-bg">
        <v-row align="center">
          <v-col cols="12" md="12">
            <v-stepper v-model="data.steps" class="elevation-0 transparent">
              <v-stepper-items>
                <v-stepper-content step="0" class="pa-0">
                  <Step0Component :data="data" :questions="questions" />
                </v-stepper-content>
                <v-stepper-content step="1" class="pa-0">
                  <Step1Component :data="data" @goBack="goBack" />
                </v-stepper-content>
                <v-stepper-content step="2" class="pa-0">
                  <Step2Component :data="data" @goBack="goBack" />
                </v-stepper-content>
                <v-stepper-content step="3" class="pa-0">
                  <Step3Component :data="data" @goBack="goBack" />
                </v-stepper-content>
                <v-stepper-content step="4" class="pa-0">
                  <Step4Component :data="data" @goBack="goBack" />
                </v-stepper-content>
                <v-stepper-content step="5" class="pa-0">
                  <Step5Component :data="data" @goBack="goBack" />
                </v-stepper-content>
                <v-stepper-content step="6" class="pa-0">
                  <Step6Component
                    :data="data"
                    :amenitiesList="amenitiesList"
                    @goBack="goBack"
                  />
                </v-stepper-content>
                <v-stepper-content step="7" class="pa-0">
                  <Step7Component
                    :data="data"
                    :rulesList="houseRules"
                    @goBack="goBack"
                  />
                </v-stepper-content>
                <v-stepper-content step="8" class="pa-0">
                  <AddImages :data="data" />
                </v-stepper-content>
                <v-stepper-content step="9" class="pa-0">
                  <AddVideos :data="data" />
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <v-footer app>
      <CopyrightComponent />
    </v-footer>
  </v-app>
</template>

<script>
// @ is an alias to /src
import timeoutMixin from "@/mixins/timeoutMixin.js";
import FullHeaderComponent from "@/components/layout/FullHeaderComponent.vue";
import CopyrightComponent from "@/components/layout/CopyrightComponent.vue";
import Step0Component from "@/components/listing/add/Step0Component.vue";
import Step1Component from "@/components/listing/add/Step1Component.vue";
import Step2Component from "@/components/listing/add/Step2Component.vue";
import Step3Component from "@/components/listing/add/Step3Component.vue";
import Step4Component from "@/components/listing/add/Step4Component.vue";
import Step5Component from "@/components/listing/add/Step5Component.vue";
import Step6Component from "@/components/listing/add/Step6Component.vue";
import Step7Component from "@/components/listing/add/Step7Component.vue";
import AddImages from "@/components/listing/add/AddImages.vue";
import AddVideos from "@/components/listing/add/AddVideos.vue";
import ListingService from "@/services/ListingService";

export default {
  name: "AddListing",
  mixins: [timeoutMixin],
  components: {
    FullHeaderComponent,
    CopyrightComponent,
    Step0Component,
    Step1Component,
    Step2Component,
    Step3Component,
    Step4Component,
    Step5Component,
    Step6Component,
    Step7Component,
    AddImages,
    AddVideos
  },
  data() {
    return {
      error: null,
      amenitiesList: [],
      houseRules: [],
      questions: [],
      data: {
        steps: 0,
        category: "",
        type: "",
        no_guests: "1",
        no_childrens: "1",
        no_rooms: "1",
        no_bathrooms: "1",
        agrement: false,
        age_restriction: "",
        price: {
          daily: null,
          weekly: null,
          monthly: null,
          currencyCode: this.$store.state.user.prefered_currency
        },
        short_term_buffer: 1,
        long_term_buffer: 1,
        name: "",
        teaser: "",
        description: "",
        amenities: [],
        address: {
          address1: "",
          address2: "",
          city: "",
          statesprovinces: "",
          postalcode: "",
          country: ""
        },
        near_attractions: [],
        check_in_times: [],
        check_out_times: [],
        location: "",
        property_route: "",
        position: [],
        property_id: ""
      }
    };
  },
  created: function() {
    ListingService.listAmenities()
      .then(result => {
        this.amenitiesList = result.data.docs;
        this.houseRules = result.data.rules.map(e => {
          return e.ln_key;
        });
        this.questions = result.data.questions.map(e => {
          return { qus: e.ln_key, ans: "" };
        });
      })
      .catch(err => {
        this.error = err.response.data.error;
      });
  },
  methods: {
    goBack() {
      if (this.data.steps > 0) this.data.steps--;
      window.scrollTo(0, 0);
    }
  }
};
</script>
